export enum MultiFacetType {
  Line = 'Line',
  Municipality = 'Municipality',
}
